import React, { useState, useEffect } from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import { useMutation } from '@apollo/client'
import {
  PAYMENT_GATEWAY_TO_UPDATE_PLAN,
  UPDATE_PLAN_FOR_BG_ACCOUNT
} from '../../../../graphql/mutation'
import { GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT } from '../../../../graphql/query'
import { usePlan } from '../../../../context/PlanContext'

interface IProps {
  closePaymentProcessingModal: any
  closeConfirmPaymentModal: any
  closePaymentModal: any
  plan: any
  data: any
}

const ProcessingPayment: React.FC<IProps> = ({
  closePaymentProcessingModal,
  closeConfirmPaymentModal,
  closePaymentModal,
  plan,
  data
}) => {
  const [progress, setProgress] = useState(0)
  const [paymentCompleted, setPaymentCompleted] = useState(false)
  const [invoiceNumber, setInvoiceNumber] = useState<string | null>(null)
  const { currentPlan } = usePlan()
  const [selectedPlan, setSelectedPlan] = useState<any>('')
  const [stopProgressBar, setStopProgressBar] = useState<any>(false)
  const [paymentGateWayToUpdatePlan] = useMutation(PAYMENT_GATEWAY_TO_UPDATE_PLAN, {
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  const [updatePlanForBgAccount] = useMutation(UPDATE_PLAN_FOR_BG_ACCOUNT, {
    refetchQueries: [
      {
        query: GET_CURRENT_PLAN_AND_BILLING_DETAILS_BY_BG_ACCOUNT,
        variables: {
          input: {
            bgAccountId: currentPlan?.bgAccountId
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'AdminPermission'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    }
  })

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => (prev < 100 ? prev + 10 : 100))
    }, 500)

    if (progress === 100) {
      clearInterval(interval)

      setStopProgressBar(true)
      // Call closePaymentProcessingModal if you want to close modal after completion
      // closePaymentProcessingModal()
    }

    return () => clearInterval(interval)
  }, [progress, closePaymentProcessingModal])

  useEffect(() => {
    if (stopProgressBar) {
      paymentGateWayToUpdatePlan({
        variables: {
          input: {
            bgAccountId: currentPlan?.bgAccountId,
            packageFeatureId: plan?.packageFeatureId,
            payingAmount: data?.getAmountForSelectedPlan?.data
          }
        }
      })
        .then((res: any) => {
          console.log(res)
          if (res.data) {
            console.log(res)
            setInvoiceNumber(res?.data?.paymentGatewayToUpdatePlan?.invoiceNumber)
            setSelectedPlan(plan?.package?.packageName)
            updatePlanForBgAccount({
              variables: {
                input: {
                  bgAccountId: currentPlan?.bgAccountId,
                  packageFeatureId: plan?.packageFeatureId,
                  invoiceNumber: String(res?.data?.paymentGatewayToUpdatePlan?.invoiceNumber)
                }
              }
            })
              .then((res: any) => {
                console.log(res)
                if (res.data) {
                  setPaymentCompleted(true)
                } else {
                  closePaymentProcessingModal()
                }
              })
              .catch((err: any) => {
                console.log(err)
                closePaymentProcessingModal()
              })
          }
        })
        .catch((err: any) => {
          console.log(err)
          closePaymentProcessingModal()
        })
    }
  }, [stopProgressBar])

  const closeAllModal = () => {
    closePaymentProcessingModal()
    closeConfirmPaymentModal()
    closePaymentModal()
  }

  return (
    <div className='card h-xl-100'>
      <div className='card-body d-flex flex-column pt-13 pb-14'>
        <div className='m-0'>
          {!paymentCompleted ? (
            <>
              <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Processing Payment</h1>
              <div className='flex-grow-1 card-rounded-bottom h-200px mh-200px my-5 mb-lg-12'>
                <div style={{ width: '200px', height: '300px', margin: '0 auto' }}>
                  <CircularProgressbar
                    value={progress}
                    text={`${progress}%`}
                    styles={buildStyles({
                      pathColor: `rgba(60, 179, 113, ${progress / 100})`,
                      textColor: '#000000',
                      trailColor: '#d6d6d6',
                      backgroundColor: '#3e98c7'
                    })}
                  />
                </div>
              </div>
              <h6 className='text-black text-center lh-lg mb-9'>Please Do Not Close This Page</h6>
            </>
          ) : (
            <>
              <div className='text-center'>
                <i className='bi bi-check-circle-fill display-1 text-success'></i>
              </div>
              <h1 className='fw-semibold text-black text-center lh-lg mb-9'>Payment Completed</h1>
              <h3 className='text-muted text-center lh-lg mb-9'>
                Your plan has been successfully changed to
                <h3 className='text-black'>{selectedPlan}</h3>
              </h3>
              <h5 className='text-black text-center lh-lg mb-9'>Invoice Number: {invoiceNumber}</h5>
              <div className='text-center'>
                <button className='btn btn-primary' onClick={closeAllModal}>
                  Ok
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProcessingPayment
